import { Product } from '@spartacus/core'
import { PageEvent } from '@spartacus/storefront'

export class ProductClickEvent extends PageEvent { //cuz of the list thingy

  static readonly type = 'ProductClickEvent'

  product?: Product
  event?: Event
}
